// extracted by mini-css-extract-plugin
module.exports = {"myStudyData":"index-myStudyData-1e4Au","chartTitle":"index-chartTitle-3nYcu"};